/**
 * Centralized feature flag configuration.
 *
 * Growth Marketing Suite is gated behind VITE_ENABLE_GROWTH_MARKETING.
 * When disabled, routes render a "Coming Soon" page with a waitlist CTA
 * instead of the underlying feature.
 */

function readFlag(name: string, defaultValue = false): boolean {
  const raw = (import.meta.env?.[name] as string | undefined)?.toLowerCase().trim();
  if (raw === undefined || raw === "") return defaultValue;
  return raw === "true" || raw === "1" || raw === "yes" || raw === "on";
}

export const FEATURE_FLAGS = {
  growthMarketing: readFlag("VITE_ENABLE_GROWTH_MARKETING", false),
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

export function isFeatureEnabled(key: FeatureFlagKey): boolean {
  return FEATURE_FLAGS[key] === true;
}